import { render } from "./AddNewCategory.vue?vue&type=template&id=27506324&scoped=true"
import script from "./AddNewCategory.vue?vue&type=script&lang=js"
export * from "./AddNewCategory.vue?vue&type=script&lang=js"

import "./AddNewCategory.vue?vue&type=style&index=0&id=27506324&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27506324"]])

export default __exports__